// ** React Imports
import { Suspense } from "react";
import ReactDOM from "react-dom";

// ** Chunk-Load-Retry (Strato-H2-GOAWAY-Race + stale index.html nach Deploy)
import { lazy } from "./utility/lazyRetry";

// ** Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/store";

// ** Intl & ThemeColors Context
// Phase 5: ToastContainer entfernt — User wollte keine Toast-Messages mehr.
// `toast.xxx()`-Calls in der Codebase werden zu No-Ops ohne Container.
import { ThemeContext } from "./utility/context/ThemeColors";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

// ** i18n
//import "./configs/i18n";

// ** I18nextProvider
import "./i18n/i18n";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={null}>
      <ThemeContext>
        <LazyApp />
      </ThemeContext>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
